import cnContent from "./token/zh/cn.js";
import usContent from "./token/zh/us.js";
import jpContent from "./token/zh/jp.js";
import koContent from "./token/zh/ko.js";
import geContent from "./token/zh/ge.js";
import ukContent from "./token/zh/uk.js";
import uaeContent from "./token/zh/uae.js";

import s1Content from "./server/zh/s1.js";

export default {
  "head.index": "首页",
  "head.product": "产品",
  "head.rental": "租赁",
  "head.about": "关于我们",

  // ===== 用户下拉菜单 =====
  "menu.profile": "个人中心",
  "menu.security": "账号安全",
  "menu.settings": "设置",
  "menu.products": "产品列表",
  "menu.deposits": "存币记录",
  "menu.withdraws": "提币记录",
  "menu.walletLog": "交易记录",
  "menu.logout": "退出登录",
  "menu.logoutSuccess": "退出登录成功",

  // ===== 页脚 =====
  "footer.contactEmail": "联系邮箱",

  // ===== 首页 =====
  "home.heroTitle1": "全球新算力领主",
  "home.heroTitle2": "双轮驱动财富引擎",
  "home.heroDesc":
    "平台优先挑选被微软、OpenAI、DeepSeek等大模型巨头提前锁定租赁的成熟站点",
  "home.heroBtn": "立即获取算力收益 →",
  "home.statTrade": "日交易额",
  "home.statReliability": "可靠性",
  "home.statGlobal": "服务全球",
  "home.buildTitle1": "建设您的",
  "home.buildTitle2": "专属算力机房",
  "home.buildDesc1": "独立管理 · 独立租赁 · 收益透明 —— 我们只负责运维管理，",
  "home.buildDesc2": "一切收益归于建设者",
  "home.buildFeature1Title": "独立管理",
  "home.buildFeature1Desc": "您拥有机房的完全控制权，自主决定租赁策略与定价",
  "home.buildFeature2Title": "收益透明",
  "home.buildFeature2Desc": "实时财务数据可视化，每一笔收益清晰可查",
  "home.buildFeature3Title": "专业运维",
  "home.buildFeature3Desc": "我们负责硬件维护、网络保障、7×24小时技术支持",
  "home.buildFeature4Title": "收益全归您",
  "home.buildFeature4Desc": "扣除基础运维成本后，所有租赁收益归建设者所有",
  "home.buildBtn": "立即建设 →",
  "home.buildStatsTitle": "📈 建设收益概览",
  "home.buildStatsUpdate": "实时更新",
  "home.buildStatRooms": "已建成机房",
  "home.buildStatServers": "运行中服务器",
  "home.buildStatProfit": "建设者总收益",
  "home.buildStatPayback": "平均回本周期",
  "home.buildStatMonth": "个月",
  "home.buildCta": "🎯 立即加入，开启您的算力基建事业",
  "home.buildCtaBtn": "了解详情",
  "home.featuresBadge": "✦ 核心优势",
  "home.featuresTitle1": "为什么选择",
  "home.featuresTitle2": "AETRIVOL",
  "home.feature1Title": "高效便捷",
  "home.feature1Desc": "AETRIVOL利用自身优势，让个人有机会享受到算力时代红利",
  "home.feature2Title": "国家级安全",
  "home.feature2Desc": "多层网络防护，数据加密传输，7×24小时安全监控",
  "home.feature3Title": "高性能硬件",
  "home.feature3Desc": "NVIDIA最新一代GPU，配合高速NVMe存储和DDR5内存",
  "home.feature4Title": "全球节点",
  "home.feature4Desc": "覆盖亚太、欧洲、北美数据中心，低延迟全球加速",
  "home.appBadge": "📱 移动端",
  "home.appTitle": "敬请期待",
  "home.appDesc1": "AETRIVOL 移动端 App 敬请期待，",
  "home.appDesc2": "让您随时随地掌握算力市场动态，",
  "home.appDesc3": "一键管理您的 GPU 算力。",
  "home.appQrText": "扫码下载 App",
  "home.appStore": "App Store",
  "home.googlePlay": "Google Play",
  "home.walletsTitle1": "合作",
  "home.walletsTitle2": "伙伴",
  "home.walletsDesc": "连接您信任的钱包，安全管理资产",
  "home.settleTitle1": "实时",
  "home.settleTitle2": "结算动态",
  "home.settleDesc": "全球用户实时收益结算展示",
  "home.modalTitle": "敬请期待",
  "home.modalDesc1": "目前暂无新机房建设项目",
  "home.modalDesc2": "感谢您的关注与支持！",
  "home.modalBtn": "我知道了",

  // ===== 首页-算力国家 =====
  "tokenList.title1": "选择您的",
  "tokenList.title2": "算力国家",
  "tokenList.desc": "全球领先算力国家，低投入、高回报",
  "tokenList.buy": "立即购买",
  "tokenList.more": "更多产品",
  "tokenList.tagHot": "🔥 热门",
  "tokenList.tagProfit": "💰 高收益",

  // ===== 首页-服务器租赁 =====
  "serverList.title1": "服务器",
  "serverList.title2": "租赁",
  "serverList.desc": "成熟高性能服务器，助您产生超额的租赁收益",
  "serverList.dailyIncome": "日收益",
  "serverList.value": "服务器价值",
  "serverList.yield": "收益率",
  "serverList.gpu": "GPU",
  "serverList.vram": "显存",
  "serverList.storage": "存储",
  "serverList.status": "状态",
  "serverList.available": "✅ 可租赁",
  "serverList.full": "⏳ 已满",
  "serverList.countdown": "距开始",
  "serverList.btnFull": "已满额",
  "serverList.btnRent": "立即租赁 →",
  "serverList.btnWait": "等待开始",
  "serverList.btnEnded": "已结束",
  "serverList.more": "查看更多产品",
  "serverList.spec1": "入门版",
  "serverList.spec2": "轻量版",
  "serverList.spec3": "性能版",
  "serverList.spec4": "旗舰版",
  "serverList.tagHot": "🔥 热门",
  "serverList.tagRecommend": "⭐ 推荐",
  "serverList.tagNew": "🌟 新上市",

  // ===== 首页-结算轮播 =====
  "settle.amount": "结算金额",
  "settle.status": "已结算",
  "settle.power": "算力值",
  "settle.rental": "服务器租赁",
  "settle.basic": "基本收益",
  "settle.cycle": "周期收益",
  "settle.phase1": "一阶段",
  "settle.phase2": "二阶段",
  "settle.phase3": "三阶段",
  "settle.phase4": "四阶段",

  // ===== 会员中心 =====
  "member.recharge": "充值",
  "member.withdraw": "提现",
  "member.tabProducts": "我的产品",
  "member.tabHistory": "历史记录",
  "member.tabWalletLog": "钱包记录",
  "member.tabDeposits": "存币记录",
  "member.tabWithdraws": "提现记录",
  "member.tabAddresses": "提现地址",

  // ===== 租赁列表页 =====
  "rental.title1": "服务器",
  "rental.title2": "租赁",
  "rental.desc": "精选高性能服务器，投资您的个人算力资产，助力全球算力发展",
  "rental.statServers": "可租赁服务器",
  "rental.statAvailability": "可用性",
  "rental.statSupport": "客服支持",
  "rental.searchPlaceholder": "搜索服务器名称、GPU型号...",
  "rental.filterAll": "全部",
  "rental.filterHot": "🔥 热门",
  "rental.filterRecommend": "⭐ 推荐",
  "rental.filterNew": "🌟 新上市",
  "rental.sortRemainingAsc": "剩余 ↑",
  "rental.sortRemainingDesc": "剩余 ↓",
  "rental.sortValueAsc": "价值 ↑",
  "rental.sortValueDesc": "价值 ↓",
  "rental.sortStartAsc": "活动开始 ↑",
  "rental.sortStartDesc": "活动开始 ↓",
  "rental.sortEndAsc": "活动结束 ↑",
  "rental.sortEndDesc": "活动结束 ↓",
  "rental.resultCount": "共 {count} 台服务器",
  "rental.loading": "加载中...",
  "rental.empty": "没有找到匹配的服务器",
  "rental.totalValue": "总价值",
  "rental.country": "国家",
  "rental.incomeTrend": "收益趋势",
  "rental.activityPeriod": "📅 活动周期",
  "rental.remaining": "⏳ 剩余",
  "rental.days": "天",
  "rental.memory": "内存",
  "rental.storage": "存储",
  "rental.bandwidth": "带宽",
  "rental.status": "状态",
  "rental.available": "✅ 可租赁",
  "rental.full": "⏳ 已满",
  "rental.countdown": "距开始",
  "rental.btnFull": "已满额",
  "rental.btnRent": "立即租赁",
  "rental.btnWait": "等待开始",
  "rental.btnEnded": "已结束",
  "rental.btnRentList": "租赁",
  "rental.btnNotStart": "未开始",
  "rental.value": "价值",
  "rental.prev": "← 上一页",
  "rental.next": "下一页 →",
  "rental.perPage": "{count} 条/页",
  "rental.processBadge": "📋 租赁流程",
  "rental.processTitle1": "三步轻松",
  "rental.processTitle2": "租用服务器",
  "rental.step1Icon": "🔍",
  "rental.step1Title": "选择服务器",
  "rental.step1Desc": "浏览服务器列表，根据您的需求选择合适的配置",
  "rental.step2Icon": "📝",
  "rental.step2Title": "提交租赁申请",
  "rental.step2Desc": "填写租赁时长、用途等信息，提交审核",
  "rental.step3Icon": "🚀",
  "rental.step3Title": "部署使用",
  "rental.step3Desc": "审核通过后立即部署，开始您的AI算力之旅",
  "rental.ctaTitle": "还没有找到合适的服务器？",
  "rental.ctaDesc": "联系我们获取定制化方案，专业团队为您推荐最优配置",
  "rental.ctaContact": "联系客服",
  "rental.ctaFaq": "查看常见问题",
  "rental.spec1": "入门版",
  "rental.spec2": "轻量版",
  "rental.spec3": "性能版",
  "rental.spec4": "旗舰版",
  "rental.tagHot": "🔥 热门",
  "rental.tagRecommend": "⭐ 推荐",
  "rental.tagNew": "🌟 新上市",
  "rental.statusActive": "进行中",
  "rental.statusPending": "未开始",
  "rental.statusEnded": "已结束",
  "rental.income": "收益",
  "rental.monday": "周一",
  "rental.tuesday": "周二",
  "rental.wednesday": "周三",
  "rental.thursday": "周四",
  "rental.friday": "周五",
  "rental.saturday": "周六",
  "rental.sunday": "周日",

  // ===== 提现页 =====
  "withdraw.title": "💸 账户提现",
  "withdraw.desc": "快速提现，安全到账",
  "withdraw.balance": "可用余额",
  "withdraw.methodCrypto": "🪙 加密货币",
  "withdraw.methodBank": "🏦 银行提现",
  "withdraw.selectCoin": "选择币种",
  "withdraw.selectNetwork": "选择提现网络",
  "withdraw.address": "提现地址",
  "withdraw.bindAddress": "➕ 绑定地址",
  "withdraw.selectAddress": "请选择提现地址",
  "withdraw.noAddress": "暂无可用地址",
  "withdraw.noAddressTip": "⚠️ 暂无绑定的 {coin} 地址，请先",
  "withdraw.bindLink": "绑定地址",
  "withdraw.amount": "提现金额",
  "withdraw.emailCode": "邮箱验证码",
  "withdraw.emailCodePlaceholder": "请输入邮箱验证码",
  "withdraw.resend": "{count}s 后重试",
  "withdraw.sendCode": "发送验证码",
  "withdraw.expectedArrival": "预计到账",
  "withdraw.networkFee": "网络手续费",
  "withdraw.actualArrival": "实际到账",
  "withdraw.submitting": "⏳ 提交中...",
  "withdraw.confirm": "🚀 确认提现",
  "withdraw.selectFirst": "👆 请选择币种和网络",
  "withdraw.minAmount": "最小提现金额",
  "withdraw.maxAmount": "最大提现金额",
  "withdraw.all": "全部",
  "withdraw.available": "可用",
  "withdraw.insufficientBalance": "余额不足",
  "withdraw.enterAmount": "请输入提现金额",
  "withdraw.enterCode": "请输入邮箱验证码",
  "withdraw.selectAddressFirst": "请选择提现地址",
  "withdraw.success": "提现申请已提交",
  "withdraw.fail": "提现失败",
  "withdraw.arrivalTime": "10-30 分钟",
  "withdraw.noticeTitle": "📋 提现注意事项",
  "withdraw.notice1Title": "到账时间",
  "withdraw.notice1Desc":
    "加密货币提现通常需要 10-30 分钟到账，具体取决于区块链网络确认速度。",
  "withdraw.notice2Title": "最低提现金额",
  "withdraw.notice2Desc":
    "单笔提现最低金额为 0.001 BTC 或等值其他币种，低于此金额将无法提交。",
  "withdraw.notice3Title": "地址核对",
  "withdraw.notice3Desc":
    "请仔细核对提现地址，错误操作可能导致资产永久丢失，平台不承担相应责任。",
  "withdraw.notice4Title": "手续费说明",
  "withdraw.notice4Desc":
    "提现手续费由区块链网络决定，平台不额外收取费用。手续费将从提现金额中扣除。",
  "withdraw.codeError": "验证码错误",
  "withdraw.twoFactorDesc": "请输入您的两步验证码以发送邮箱验证码",
  "withdraw.selectBank": "选择银行账户",
  "withdraw.selectBankPlaceholder": "请选择银行账户",
  "withdraw.bankBOC": "中国银行",
  "withdraw.bankICBC": "工商银行",
  "withdraw.addBank": "+ 添加新账户",
  "withdraw.bankAmount": "提现金额 (USD)",
  "withdraw.exchangeRate": "💱 汇率",
  "withdraw.arrivalTimeLabel": "⏱️ 到账时间",
  "withdraw.bankArrivalTime": "1-3 个工作日",
  "withdraw.bankConfirm": "🏦 确认提现",
  "withdraw.bankSuccess": "🏦 银行提现申请已提交，1-3 个工作日内到账",

  // ===== 产品描述内容 =====
  "token.content.cn": cnContent.content,
  "token.content.us": usContent.content,
  "token.content.jp": jpContent.content,
  "token.content.ko": koContent.content,
  "token.content.ge": geContent.content,
  "token.content.uk": ukContent.content,
  "token.content.uae": uaeContent.content,

  "server.content.s8": s1Content.content,
  "server.content.s8ce": s1Content.country_desc,

  phase: "阶段",
};
